import { useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'

import { PolicyTable } from '../../types/cancelAndModifyPolicies'
import PoliciesActionRowMobile from '../RatePlansPolicies/PoliciesActionRowMobile'
import PoliciesFormAvailablePoliciesListTableHead from './PoliciesFormAvailablePoliciesListTableHead'
import PoliciesFormAvailablePoliciesRow from './PoliciesFormAvailablePoliciesRow'

interface PoliciesFormAvailablePoliciesListProps {
  policiesData: PolicyTable[]
  onDelete: (data: PolicyTable) => void
}
const PoliciesFormAvailablePoliciesList: React.FC<
  PoliciesFormAvailablePoliciesListProps
> = ({ policiesData, onDelete }) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <div>
      {!isSmallScreen && <PoliciesFormAvailablePoliciesListTableHead />}
      {policiesData.map((item, index) =>
        isSmallScreen ? (
          <PoliciesActionRowMobile
            key={item.priority + index}
            policiesData={item}
          />
        ) : (
          <PoliciesFormAvailablePoliciesRow
            key={item.priority + index}
            onDelete={onDelete}
            policiesData={item}
          />
        )
      )}
    </div>
  )
}
export default PoliciesFormAvailablePoliciesList
